import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { http } from 'wagmi';
import { createPublicClient, defineChain } from 'viem';
import officialLogo from '@/assets/cross-official-logo-crop.png';
import { runtime } from './config';

const DEFAULT_REOWN_PROJECT_ID = '10911d3f34e6aa644b2f237aaaf508e6';
const ROBINHOOD_WALLET_ID = '8837dd9413b1d9b585ee937d27a816590248386d9dbf59f5cd3422dbbb65683e';

export const robinhoodChain = defineChain({
  id: 4663,
  name: 'Robinhood Chain',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: { default: { http: [runtime().browserRpcUrl || 'https://rpc.mainnet.chain.robinhood.com'] } },
  blockExplorers: { default: { name: 'Robinhood Explorer', url: runtime().explorerUrl || 'https://robinhoodchain.blockscout.com' } },
});

const projectId = runtime().walletConnectProjectId || DEFAULT_REOWN_PROJECT_ID;
const rpcUrl = runtime().browserRpcUrl || undefined;
const wagmiAdapter = new WagmiAdapter({
  networks: [robinhoodChain],
  projectId,
  transports: { [robinhoodChain.id]: http(rpcUrl) },
  ssr: false,
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks: [robinhoodChain],
  defaultNetwork: robinhoodChain,
  projectId,
  metadata: {
    name: 'CROSS',
    description: 'Portfolio state clearing on Robinhood Chain',
    url: window.location.origin,
    icons: [`${window.location.origin}${officialLogo}`],
  },
  featuredWalletIds: [ROBINHOOD_WALLET_ID],
  allWallets: 'SHOW',
  enableEIP6963: true,
  enableBaseAccount: false,
  coinbasePreference: 'eoaOnly',
  allowUnsupportedChain: false,
  features: {
    email: false,
    socials: false,
    swaps: false,
    onramp: false,
    send: false,
    receive: false,
    history: false,
    analytics: false,
    allWallets: true,
    connectMethodsOrder: ['wallet'],
    connectorTypeOrder: ['featured', 'recent', 'injected', 'walletConnect', 'recommended'],
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#5df0b2',
    '--w3m-color-mix': '#04120d',
    '--w3m-color-mix-strength': 30,
    '--w3m-border-radius-master': '2px',
  },
});

export const publicClient = createPublicClient({ chain: robinhoodChain, transport: http(rpcUrl) });
